import { render, staticRenderFns } from "./CallMonitoring.vue?vue&type=template&id=4b12c064"
import script from "./CallMonitoring.vue?vue&type=script&lang=js"
export * from "./CallMonitoring.vue?vue&type=script&lang=js"
import style0 from "./CallMonitoring.vue?vue&type=style&index=0&id=4b12c064&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports